/**
 * CdpProxyClient — facade the daemon uses to proxy a canary `browser_*` tool
 * call to chrome-devtools-mcp, which in turn drives the user's real Chrome.
 *
 * @module
 */

import { ChromeDevtoolsMcpClient, type McpClientLogger } from './mcp-client.js';
import { translateAndCall, type ProxyResult } from './translators.js';

export class CdpProxyClient {
  private readonly mcp: ChromeDevtoolsMcpClient;

  constructor(logger?: McpClientLogger) {
    this.mcp = new ChromeDevtoolsMcpClient(logger);
  }

  async start(): Promise<void> {
    await this.mcp.start();
  }

  async callByCanaryName(
    toolName: string,
    args: Record<string, unknown>,
  ): Promise<ProxyResult> {
    const fullName = toolName.startsWith('browser_') ? toolName : `browser_${toolName}`;
    return translateAndCall(this.mcp, fullName, args);
  }

  async shutdown(): Promise<void> {
    await this.mcp.shutdown();
  }
}

export { CHROME_DEVTOOLS_MCP_VERSION } from './mcp-client.js';
export type { ProxyResult } from './translators.js';
